import React from 'react';
import { Row, Col } from 'react-bootstrap';

import { UtilityTypesLookup } from '../ReportHelpers';
import ReportCheckBoxPicker from '../../../components/reports/ReportCheckboxPicker';

export default function ReportReport(props) {
  const { organizationData, updatePayload } = props;

  return (
    <>
      <Row>
        <Col>
          <ReportCheckBoxPicker
            label={'Utility Types'}
            checkboxOptions={organizationData['utility_types_with_other']}
            checkboxLookups={UtilityTypesLookup}
            defaults={organizationData['utility_types_with_other']}
            requireds={[]}
            payload_key={'utility_types'}
            updatePayload={updatePayload}
          />
        </Col>
      </Row>
    </>
  );
}
